import {Component, inject, Signal, viewChild} from '@angular/core';
import {SplitterModule} from 'primeng/splitter';
import {LanguageTableComponent} from './language-table.component';
import {TranslationTableComponent} from './translation-table.component';
import {IControlObject} from 'frontier';
import {AlertService} from './alert.service';

@Component({
  selector: 'app-language-config',
  standalone: true,
  imports: [SplitterModule, LanguageTableComponent, TranslationTableComponent],
  templateUrl: './language-config.component.html',
  styleUrl: './language-config.component.scss',
})
export class LanguageConfigComponent {
  private _alertService: AlertService = inject(AlertService);

  alertObjects: Signal<IControlObject[]> = this._alertService.languageAlertObjects.asReadonly();

  getAlertOverview(): string {
    return 'Bei folgenden Sprachen sind die Bezeichnungen momentan unvollständig: ' +
      this.alertObjects().map((a: IControlObject): string => a.name).join(', ');
  }

  languageRef: Signal<LanguageTableComponent> = viewChild(LanguageTableComponent);

  protected onLanguageResolved(evt: IControlObject): void {
    this._alertService.languageAlertObjects.set(this.alertObjects()
      .filter((obj: IControlObject): boolean => obj.signature !== evt.signature));
  }
}
